/**
 * Student portal RBAC (Spatie names) from login / GET student/auth/permissions.
 * If `student-permissions` is absent from localStorage, all checks pass (legacy sessions until sync).
 */
export function getStudentPermissionsFromStorage() {
  try {
    if (localStorage.getItem("student-permissions") === null) {
      return null;
    }
    const raw = localStorage.getItem("student-permissions");
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function studentHasPermission(permission) {
  if (!permission || typeof permission !== "string") return false;
  const list = getStudentPermissionsFromStorage();
  if (list === null) return true;
  return list.includes(permission);
}

export function studentHasAllPermissions(permissions) {
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  const list = getStudentPermissionsFromStorage();
  if (list === null) return true;
  return permissions.every((p) => list.includes(p));
}

export function studentHasAnyPermission(permissions) {
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  const list = getStudentPermissionsFromStorage();
  if (list === null) return true;
  return permissions.some((p) => list.includes(p));
}
